// 11 hart-gecodete Kategorien (deutsch) — Phase 11.
// Quelle: Scrolly Platform.html, übersetzt laut Session-C-Entscheidung.
// Plus Sprint-1-Cover-Page-Fallback: "story" als hidden-Default für
// Backend-driven Scrollys ohne categoryName (Bene-Entscheidung 2026-05-19).

export type CategoryId =
  | "all"
  | "trending"
  | "data"
  | "journalism"
  | "science"
  | "design"
  | "history"
  | "travel"
  | "business"
  | "howto"
  | "brand"
  | "story";

export type Category = {
  id: CategoryId;
  label: string;
  englishLabel: string; // für Mock-Scrolly-category-Felder
  /** Wenn true: NICHT in Filter-UI-Chips rendern. Sprint-1-Fallback-
   * Default für Backend-Scrollys ohne categoryName — kein Filter-Item. */
  hidden?: boolean;
};

export const CATEGORIES: Category[] = [
  { id: "all", label: "Für dich", englishLabel: "For you" },
  { id: "trending", label: "Im Trend", englishLabel: "Trending" },
  { id: "data", label: "Datenstorys", englishLabel: "Data stories" },
  { id: "journalism", label: "Journalismus", englishLabel: "Journalism" },
  { id: "science", label: "Wissenschaft", englishLabel: "Science" },
  { id: "design", label: "Design", englishLabel: "Design" },
  { id: "history", label: "Geschichte", englishLabel: "History" },
  { id: "travel", label: "Reise", englishLabel: "Travel" },
  { id: "business", label: "Business", englishLabel: "Business" },
  { id: "howto", label: "Anleitungen", englishLabel: "How-to" },
  { id: "brand", label: "Brand", englishLabel: "Brand" },
  // Sprint-1-Fallback-Default. NICHT in Filter-UI (hidden:true). Wird
  // von synthScrollyFromResolved verwendet wenn Backend categoryName
  // nicht liefert. Forward-Compat: sobald Backend categoryName setzt,
  // greift der `categoryName ?? "story"`-Fallback nicht mehr.
  { id: "story", label: "Story", englishLabel: "Story", hidden: true },
];

/** Categories für Filter-UI-Konsum (CategoryChips, Discover-Page, etc.).
 * Filtert hidden-flagged Defaults wie "story" aus. */
export const VISIBLE_CATEGORIES: Category[] = CATEGORIES.filter(
  (c) => !c.hidden,
);

export const CATEGORY_BY_ID = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c]),
) as Record<CategoryId, Category>;
